/**
 * Returns percentage string from provided float number
 */
export default function toPercentString(value: number): string {
    return value === Number.NaN ? '' : (100 * value).toString() + '%';
}
